import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {LinePlotDisplayFnArgs} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';

export const getXAxisMaxDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currTemplateXAxisMax = currTemplateLinePlotSettings?.xAxisMax;
  const newTemplateXAxisMax = currWorkspaceLinePlotSettings?.xAxisMax;

  return {
    label: 'X axis max',
    field: 'xAxisMax' as keyof LinePlotTemplateSettings,
    currValue: currTemplateXAxisMax,
    currDisplayValue:
      currTemplateXAxisMax == null
        ? undefined
        : currTemplateXAxisMax.toString(),
    newValue: newTemplateXAxisMax ?? DEFAULT_LINE_PLOT_SETTINGS.xAxisMax,
    newDisplayValue:
      newTemplateXAxisMax == null ? undefined : newTemplateXAxisMax.toString(),
  };
};
